import styled from 'styled-components';

const HnCarouselHolder = styled.div`
  .hn__content {
    margin: 0 15px;
    position: relative;
    a {
      text-decoration: none;
      font-family: var(--font-family-primary);
    }
    h2:focus-visible {
      text-decoration: underline;
    }
    a.seeAllBtn {
      position: absolute;
      right: 20px;
      top: .75rem;
      color: var(--clr-white);
      font-weight: 700;
      text-transform: uppercase;
      font-size: var(--font-size-medium-1);
      @media only screen and (max-width: 548px) {
          font-size: var(--font-size-small-2);
          top: .5rem;
      }
    }
    a.seeAllBtn:focus-visible,
    a.seeAllBtn:hover {
      text-decoration-line: underline overline !important;
      text-decoration-thickness: 3px !important;
      text-underline-offset: 5px;
    }
    .hn__Header-bottom a.seeAllBtn {
      position: inherit;
   }

    ul {
      list-style: none;
      padding: 0;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-auto-rows: auto;
      gap: 25px;
      margin: 0 auto;
      max-width: calc(100% - 50px);
      /* Landscape iPad */
      @media screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
        grid-template-columns: repeat(2, 1fr);
      }
      /* Portrait iPad Pro */
      @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media screen and (max-width: 920px) {
        grid-template-columns: repeat(2, 1fr);
      }
      /* iPhone SE */
      @media screen and (max-width: 548px) {
        grid-template-columns: 1fr;
      }

      li {
        background-color: var(--hncarousel-bg-color);
        margin-bottom: 12px;
        position: relative;

        h3 {
          font-size: 17px;
          text-transform: uppercase;
          font-weight: 700;
          color: var(--hncarousel-h3-text-color);
          margin: 0 0 5px 0 !important;
        }

        p {
          margin: 0;
          font-weight: 500;
          font-size: 17px;
          color: var(--headings-text-color);
          line-height: 1.6em;
        }

        .header__container {
          position: relative;
          //padding-top: calc((9 * var(--aspect-ratio-image-width)) / 16);

          img {
            width: 100%;
            height: 100%;
          }
          .testFlag {
						position: absolute;
						top: 0;
						right: 0;
						background: var(--clr-white);
						border: 1px solid var(--clr-black);
						padding: 5px;
						color: var(--clr-test-flag);
						font-weight: bold;
					}
        }

        .description__container {
          padding: 8px 20px 8px 20px;
          & a:hover {
            text-decoration: underline !important;
            text-decoration-color: var(--headings-text-color) !important;
          }
          & a:focus-visible .episode-title {
              outline: var(--focus-visible-outline);
          }
          & p.series-title {
              font-weight: 700;
              text-transform: uppercase;
              margin: 0 0 5px 0 !important;
              color: var(--hncarousel-h3-text-color);
              line-height: 1.2em;
          }
          & .episode-date {
            font-size: var(--font-size-small-1);
            font-weight: 600;
            color: var(--hncarousel-h3-text-color);
          }
        }
      }
    }
  }
`;

export default HnCarouselHolder;